//CART ACTION TYPES
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const APPLY_COUPON = "APPLY_COUPON";
export const COUPON_ERROR = "COUPON_ERROR";
export const LOADING = "LOADING";
export const CLEAR_CART = "CLEAR_CART";
export const CLOSE_CART = "CLOSE_CART";
export const OPEN_CART = "OPEN_CART";